module.exports = __webpack_public_path__ + "img/veggies.ab7c3cb6.jpg";